import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormGranulePelletIcon.tsx
const MedFormGranulePelletIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "granule-pellet-icon.svg",
		alt: t("medicationForm.granulePellet")
	});
};

//#endregion
export { MedFormGranulePelletIcon };